// The server signed this session out with a reason (LOGIN_CODE_REQUIRED: a platform role that needs a login code,
// on a session that never entered one). Keep the message for the login page (shown once), end the session on the
// server (clears the auth cookies, so a reload doesn't repeat it) and drop the stored tokens.
import axios from 'axios';
import { clearTokens } from '@/lib/authToken';

const KEY = 'sx_login_notice';
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
let handled = false;  // once per page: every in-flight request comes back with the same 401

const codeRequired = (err) => {
  const d = err?.response?.data?.detail;
  return d && typeof d === 'object' && d.code === 'LOGIN_CODE_REQUIRED' ? d : null;
};

// → 'first' (handled now: caller should go to /login), 'again' (already handled on this page), or false
export async function signOutForReason(err) {
  const d = codeRequired(err);
  if (!d) return false;
  if (handled) return 'again';
  handled = true;
  try { sessionStorage.setItem(KEY, d.message || 'Your access changed. Sign in again with a login code.'); } catch { /* private mode */ }
  try { await axios.post(`${API}/auth/logout`, {}, { withCredentials: true }); } catch { /* cookies may already be gone */ }
  clearTokens();
  return 'first';
}

export function takeLoginNotice() {
  try {
    const m = sessionStorage.getItem(KEY);
    sessionStorage.removeItem(KEY);
    return m;
  } catch { return null; }
}
